/* Aelse stones (2026-10-04, her pick A): the colour name under the card's stone row while a stone is hovered or
   keyboard-focused. Nothing else: no Back (her 20:13 note), the first stone is the way back. The photo swap is the
   theme's own ProductCard element (assets/theme.js) reacting to the radio change; this file never touches images.
   A pointer press marks the row 'is-mouse' so a mouse click leaves no focus ring; a key press clears it so
   keyboard users keep theirs. Record: brands/aelse/shopify-theme/2026-10-04-colour-swatches/_note.md */
(function () {
  if (window.__aeStones) return;
  window.__aeStones = true;
  var SEL = '.ae-stones';
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function wrap(el) { return el && el.closest ? el.closest(SEL) : null; }
  function nameOf(label) { var s = label && label.querySelector('.sr-only'); return s ? s.textContent.trim() : ''; }
  function labelFor(input) { return input && input.id ? document.querySelector('label[for="' + CSS.escape(input.id) + '"]') : null; }
  function nameHTML(label) { return '<span>' + esc(nameOf(label)) + (label.classList.contains('is-disabled') ? ' <span class="ae-stones__so">· sold out</span>' : '') + '</span>'; }
  function setLabel(w, html) { var lab = w && w.querySelector('.ae-stones__label'); if (lab) lab.innerHTML = html; }
  document.addEventListener('pointerover', function (e) {
    var l = e.target.closest && e.target.closest(SEL + ' .color-swatch'); if (!l) return;
    setLabel(wrap(l), nameHTML(l));
  });
  document.addEventListener('pointerout', function (e) {
    var l = e.target.closest && e.target.closest(SEL + ' .color-swatch'); if (!l) return;
    var w = wrap(l); var f = w && w.querySelector('input[type="radio"]:focus-visible');
    setLabel(w, f && !w.classList.contains('is-mouse') ? nameHTML(labelFor(f)) : '');
  });
  document.addEventListener('pointerdown', function (e) {
    var w = wrap(e.target); if (w) w.classList.add('is-mouse');
  });
  document.addEventListener('keydown', function (e) {
    // a Tab or arrow key anywhere means keyboard navigation: every row gets its focus ring back
    if (!/^(Tab|Arrow)/.test(e.key)) return;
    var rows = document.querySelectorAll(SEL + '.is-mouse');
    for (var i = 0; i < rows.length; i++) rows[i].classList.remove('is-mouse');
  });
  document.addEventListener('focusin', function (e) {
    var i = e.target; if (!(i.matches && i.matches(SEL + ' input[type="radio"]'))) return;
    var w = wrap(i); if (w.classList.contains('is-mouse')) return;
    var l = labelFor(i); if (l) setLabel(w, nameHTML(l));
  });
  document.addEventListener('focusout', function (e) {
    var i = e.target; if (!(i.matches && i.matches(SEL + ' input[type="radio"]'))) return;
    setLabel(wrap(i), '');
  });
})();
